import React from "react";
import EventCard from "./EventCard";
import { useAccount } from "../../Contexts/AccountContext";

interface DateItemProps {
    dateItem: {
        date: string;
        events: any[];
    };
    index: number;
    openAccordion: string | null;
    toggleAccordion: (date: string) => void;
}

export default ({ dateItem, index, openAccordion, toggleAccordion }: DateItemProps) => {
    const { dictionary } = useAccount();
    const isExpanded = openAccordion === dateItem.date;
    const accordionId = `accordion-${index}`;
    const headerId = `${accordionId}-header`;
    const contentId = `${accordionId}-content`;
    
    return (
        <div className="accordion-item">
            <div className="accordion-header" id={headerId}>
                <button 
                    className={`fw-bold accordion-button ${isExpanded ? '' : 'collapsed'}`}
                    type="button" 
                    onClick={() => toggleAccordion(dateItem.date)}
                    aria-expanded={isExpanded}
                    aria-controls={contentId}
                    id={`${accordionId}-button`}
                >
                    {dateItem.date}
                </button>
            </div>
            <div 
                id={contentId}
                className={`accordion-collapse ${isExpanded ? 'show' : 'collapse'}`}
                aria-labelledby={headerId}
                role="region"
            >
                <div className="accordion-body">
                    <h3 id={`${accordionId}-events-heading`} 
                        className="visually-hidden">
                        Events for {dateItem.date}
                    </h3>
                    {dateItem.events.length > 0 ? (
                        <div className="row" 
                            role="list" 
                            aria-labelledby={`${accordionId}-events-heading`}
                            aria-describedby={`${accordionId}-events-count`}
                        >
                            <div 
                                id={`${accordionId}-events-count`} 
                                className="visually-hidden"
                            >
                                {dateItem.events.length} event{dateItem.events.length !== 1 ? 's' : ''} available
                            </div>
                            {dateItem.events.map((event, eventIndex) => (
                                <div key={eventIndex} className="col-md-4" role="listitem">
                                    <EventCard event={event} />
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p role="status" aria-live="polite">
                            {dictionary.get("MyAccount:ClassNEvents:Date:NotFoundDescription") ?? 'No events for this date.'}
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};
